module.exports = __webpack_public_path__ + "img/Gobelets_de_mariage.caa2fa2.jpg";